import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Modal, Select, Tag } from 'antd';
import { handleErrorMessages, handleSuccessMessages } from '../../helpers/flashMessages';
import EmailApis from '../../api/email';
import { useAlert } from 'react-alert';

const ConfirmationEmailModal = ({
  emailFormData,
  isModalVisible,
  setIsModalVisible,
  setSelectedRows,
  setSelectedEmails,
  selectAllFilters,
  setSelectAllFilters,
  filters,
}) => {
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [previewData, setPreviewData] = useState({ total: 0, emails: [] });
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [previewSearch, setPreviewSearch] = useState('');
  const [segmentName, setSegmentName] = useState('');
  const [excludedEmails, setExcludedEmails] = useState([]);

  useEffect(() => {
    if (isModalVisible) {
      setExcludedEmails([]);
      fetchPreview();
    }
  }, [isModalVisible]);

  const fetchPreview = async () => {
    try {
      setLoadingPreview(true);
      const payload = {
        emails: emailFormData.emails,
        filters: selectAllFilters ? filters : {},
        selectAll: selectAllFilters,
      };
      const response = await EmailApis.previewImportAudience(payload);
      setPreviewData(response.data);
    } catch (e) {
      handleErrorMessages(e, alert);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCancelClick = () => {
    setIsModalVisible(false);
    setSelectedRows([]);
    setSelectedEmails([]);
  };

  const onFinish = async e => {
    e.preventDefault();

    // Create an object of formData
    const payload = {
      emails: emailFormData.emails,
      filters: selectAllFilters ? filters : {},
      selectAll: selectAllFilters,
      tags: segmentName ? [segmentName] : [],
      excludedEmails: excludedEmails,
    };

    try {
      setLoading(true);
      const response = await EmailApis.addToAudience(payload);
      setIsModalVisible(false);
      console.log(response?.data, 'response');

      handleSuccessMessages(response, alert);
      setSelectedRows([]);
      setSelectedEmails([]);
    } catch (e) {
      handleErrorMessages(e, alert);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveEmail = data => {
    setExcludedEmails([...excludedEmails, data.email]);
    setSelectedEmails(prev => prev.filter(e => e !== data.email));
    if (data._id) {
      setSelectedRows(prev => prev.filter(id => id !== data._id));
    }
    setSelectAllFilters(false);
  };

  const filteredEmails = previewData.emails
    .filter(item => item.email.toLowerCase().includes(previewSearch.toLowerCase()))
    .filter(item => !excludedEmails.includes(item.email));

  const totalImportCount = previewData.total - excludedEmails.length;

  return (
    <Modal
      title="Confirm Email's"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={800}
      footer={null}
      maskClosable={false}
      preserve={false}
      destroyOnClose={true}
    >
      <form className="flex flex-col" onSubmit={e => onFinish(e)}>
        {loadingPreview ? (
          <div className="text-center py-5">
            <p>Loading preview...</p>
          </div>
        ) : (
          <div>
            <p className="mb-4 text-md font-semibold">
              You are about to import {totalImportCount} emails to Mailchimp.
            </p>
            <div className="mb-4">
              {/* <input
                type="text"
                placeholder="Search emails in preview..."
                className="w-full p-2 border rounded mb-2"
                value={previewSearch}
                onChange={e => setPreviewSearch(e.target.value)}
              /> */}
              <label className="text-bold">Tag Name</label>

              <Input
                name="Enter Tag Name"
                value={segmentName}
                className="mt-1 mb-3"
                onChange={e => setSegmentName(e.target.value)}
                placeholder="Enter Tag Name"
              />
            </div>
            {previewData.emails.length > 0 && (
              <div className="flex gap-2 flex-wrap max-h-60 overflow-y-auto">
                <p className="w-full text-sm text-gray-500 mb-2">Preview of emails:</p>
                <Input
                  name="Search emails in preview"
                  value={previewSearch}
                  className="mt-1 mb-3"
                  onChange={e => setPreviewSearch(e.target.value)}
                  placeholder="Search emails in preview..."
                />
                {filteredEmails.map((item, index) => (
                  <Tag
                    closable
                    onClose={e => {
                      e.preventDefault();
                      handleRemoveEmail(item);
                    }}
                    color="blue"
                    key={index}
                    style={{ fontSize: '14px', padding: '5px 10px', display: 'flex', alignItems: 'center' }}
                  >
                    {item.email}
                  </Tag>
                ))}
                {!previewSearch && previewData.total > previewData.emails.length && (
                  <p className="w-full text-sm text-gray-500 mt-2">
                    ...and {previewData.total - previewData.emails.length} more.
                  </p>
                )}
              </div>
            )}
          </div>
        )}
        <div>
          <button
            type="submit"
            className={`px-5 py-3 mt-5 text-white rounded-sm bg-primary hover:bg-primary-light modal-button ${
              loading || loadingPreview ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            disabled={loading || loadingPreview}
          >
            {loading ? 'Importing...' : 'Import'}
          </button>
          <button
            type="button"
            className="px-5 py-3 mt-5 mr-3 text-white rounded-sm bg-secondary_disabled modal-button"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

ConfirmationEmailModal.propTypes = {
  emailFormData: PropTypes.object,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func,
  setSelectedRows: PropTypes.func,
  setSelectedEmails: PropTypes.func,
  selectAllFilters: PropTypes.bool,
  setSelectAllFilters: PropTypes.func,
  filters: PropTypes.object,
};

export default ConfirmationEmailModal;
